/**
 * Normalize media URLs from the API to same-origin /storage/ paths.
 * Also recovers usable audio MIME hints from the path when the object
 * was stored without a proper extension.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== "string") return url;
  const cleaned = url
    .replace(/^https?:\/\/minio(?::\d+)?\/media\//, "/storage/")
    .replace(/[?&](AWSAccessKeyId|Signature|Expires)=[^&]*/g, "")
    .replace(/\?&/, "?")
    .replace(/[?&]$/, "");
  try {
    const parsed = new URL(cleaned, window.location.origin);
    if (parsed.pathname.startsWith("/storage/")) {
      return `${parsed.pathname}${parsed.search}`;
    }
  } catch {
    // use cleaned value
  }
  return cleaned;
}

export function attachmentHref(file) {
  if (!file) return null;
  const raw = typeof file === "string" ? file : file.file;
  return resolveMediaUrl(raw);
}

export function guessAudioMime(url) {
  if (!url || typeof url !== "string") return undefined;
  const path = url.split("?")[0].toLowerCase();
  if (path.endsWith(".webm") || path.endsWith(".weba")) return "audio/webm";
  if (path.endsWith(".ogg") || path.endsWith(".oga")) return "audio/ogg";
  if (path.endsWith(".mp3") || path.endsWith(".mpeg") || path.endsWith(".mpga"))
    return "audio/mpeg";
  if (path.endsWith(".wav")) return "audio/wav";
  if (path.endsWith(".m4a") || path.endsWith(".mp4") || path.endsWith(".aac"))
    return "audio/mp4";
  // Extensionless uploads from MediaRecorder are almost always webm
  if (/\/feedback\.?$/.test(path) || /\.$/.test(path)) return "audio/webm";
  return undefined;
}

export function isLikelyImageUrl(url) {
  if (!url || typeof url !== "string") return false;
  const path = url.split("?")[0].toLowerCase();
  return /\.(jpe?g|png|gif|webp|bmp|svg)$/.test(path);
}

export function collectFeedbackFiles(data) {
  if (!data) return [];
  const files = [];
  if (data.file) files.push(data.file);
  for (const reply of data.criteria_replies || []) {
    if (Array.isArray(reply.files)) {
      for (const f of reply.files) {
        if (f) files.push(f);
      }
    }
  }
  return files.filter(Boolean);
}
